module.exports = __webpack_public_path__ + "static/media/Window.5ccd5273.png";